// extracted by mini-css-extract-plugin
export default {"container":"NewThem_container__XP1CS"};